var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spider-history"},[_c('div',{staticClass:"mx-6 my-6",staticStyle:{"height":"400px"}},[(_vm.items.length != 0)?_c('line-chart',{attrs:{"data":_vm.chart,"options":_vm.options}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }